import React from "react";
// JOB-3343: Auth-route entry points are eagerly imported (not React.lazy) so
// their CSS ships in the main entry bundle and is render-blocking from
// `index.html`. With Vite per-route CSS chunks these otherwise race React's
// first paint, producing intermittent FOUC (single-column layout flash) on
// cold-cache `/auth/login` and `/auth/signup` visits.
import Login from "./components/Login";
import SignUp from "./components/Login/SignUp";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
const DispatchBoard = React.lazy(() => import("./Views/Admin/Dispatch/DispatchBoard"));
const WorkerLocationMap = React.lazy(() => import("./Views/Admin/Dispatch/WorkerLocationMap"));
const AnnouncementsPage = React.lazy(() => import("./Views/Admin/Announcements/AnnouncementsPage"));
const TimeOffApprovalPage = React.lazy(() => import("./Views/Admin/TimeOff/TimeOffApprovalPage"));
const ShiftTransactionsPage = React.lazy(() => import("./Views/Admin/ShiftRequests/ShiftTransactionsPage"));
const TimeReportsPage = React.lazy(() => import("./Views/Admin/TimeReports/TimeReportsPage"));
const TimeSettingsPage = React.lazy(() => import("./Views/Admin/TimeSettings/TimeSettingsPage"));
const KioskPage = React.lazy(() => import("./Views/Kiosk/KioskPage"));
const SuperadminDashboard = React.lazy(() => import("./Views/Dashboard/Superadmin"));
const AdminDashboard = React.lazy(() => import("./Views/Dashboard/Admin"));
import client from "./assets/image/icons/client.svg";
const Company = React.lazy(() => import("./Views/Superadmin/Company/Index"));
const CompanyDetail = React.lazy(() => import("./Views/Superadmin/Company/CompanyDetail"));
const Plan = React.lazy(() => import("./Views/Admin/Plan/Index"));
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
const ClientDetails = React.lazy(() => import("./Views/Admin/Client/CustomerDetails"));
const Client = React.lazy(() => import("./Views/Admin/Client/Customer"));
const AddClient = React.lazy(() => import("./Views/Admin/Client/AddClient"));
import SentimentSatisfiedOutlinedIcon from "@mui/icons-material/SentimentSatisfiedOutlined";
const Quotes = React.lazy(() => import("./Views/Admin/Quotes/Quote"));
const Addquotes = React.lazy(() => import("./Views/Admin/Quotes/Addquotes"));
const ServiceRequestsPage = React.lazy(() => import("./Views/Admin/ServiceRequests/index"));
const ServiceRequestDetail = React.lazy(() => import("./Views/Admin/ServiceRequests/ServiceRequestDetail"));
const AddServiceRequest = React.lazy(() => import("./Views/Admin/ServiceRequests/AddServiceRequest"));
const ClientServiceRequests = React.lazy(() => import("./Views/Customer/ServiceRequests"));
const ClientServiceRequestDetail = React.lazy(() => import("./Views/Customer/ServiceRequestDetail"));
// JOB-3343: same FOUC reason — eager import.
import ForgotPassword from "./components/Login/ForgotPassword";
import NewPassword from "./components/Login/ResetPssword";
const Setting = React.lazy(() => import("./components/Setting/SettingSidebar"));
const MaterialsLabor = React.lazy(() => import("./Views/Admin/Setting/Materials&Labor/index"));
const PropertyDetails = React.lazy(() => import("./Views/Admin/Client/Customer-Property/PropertyDetails"));
const AddContract = React.lazy(() => import("./Views/Admin/Contract/AddContract"));
const MaterialsAndLaborSuperadmin = React.lazy(() => import("./Views/Superadmin/MaterialsAndLabor/index"));
const AddTemplates = React.lazy(() => import("./Views/Admin/Communications/AddTemplates"));
const Job = React.lazy(() => import("./Views/Admin/Contract/Contract"));
const ClientDashboard = React.lazy(() => import("./Views/Dashboard/Client"));
const ClientQuotes = React.lazy(() => import("./Views/Customer/Quotes"));
const ClientQuotesdetail = React.lazy(() => import("./Views/Customer/Quotesdetail"));
const Templates = React.lazy(() => import("./Views/Admin/Communications/Templates"));
// JOB-3343: same FOUC reason — eager import.
import ResetPassword from "./components/Login/NewPassword";
const QuotesDetail = React.lazy(() => import("./Views/Admin/Quotes/QuotesDetail"));
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DescriptionIcon from "@mui/icons-material/Description";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
const Profile = React.lazy(() => import("./Views/Admin/Setting/Profile/index"));
const CustomerProfile = React.lazy(() => import("./Views/Admin/Setting/Profile/CustomerProfile"));
const SuperAdminProfile = React.lazy(() => import("./Views/Admin/Setting/Profile/Superadminprofile"));
const StaffMemberProfile = React.lazy(() => import("./Views/Admin/Setting/Profile/StaffMemberProfile"));
const SuperAdminManagement = React.lazy(() => import("./Views/Superadmin/SuperAdminManagement"));
const ContractDetails = React.lazy(() => import("./Views/Admin/Contract/Contractdetails"));
const ManageTeamTable = React.lazy(() => import("./Views/Admin/Setting/Manage Team/ManageTeamTable"));
const ManageTemplates = React.lazy(() => import("./Views/Admin/Setting/Manage Templates/ManageTemplates"));
const EmailSettings = React.lazy(() => import("./Views/Admin/Setting/Email Settings/EmailSettings"));
const InvoiceSettings = React.lazy(() => import("./Views/Admin/Setting/Invoice Settings/InvoiceSettings"));
const AddUser = React.lazy(() => import("./Views/Admin/Setting/Manage Team/AddUser"));
const SuperadminPlan = React.lazy(() => import("./Views/Superadmin/Plan/Plan"));
const UserDetails = React.lazy(() => import("./Views/Admin/Setting/Manage Team/UserDetails"));
const WorkerDetail = React.lazy(() => import("./Views/Admin/Setting/Manage Team/WorkerDetail"));
const StaffMember = React.lazy(() => import("./Views/Dashboard/StaffMember"));
const EmailLogs = React.lazy(() => import("./Views/Admin/Communications/Email logs/EmailLogs"));
const EmailCampaignList = React.lazy(() => import("./Views/Admin/Communications/EmailBlast/EmailCampaignList"));
const AddEmailCampaign = React.lazy(() => import("./Views/Admin/Communications/EmailBlast/EmailCampaign"));
const EmailCampaignDetails = React.lazy(() => import("./Views/Admin/Communications/EmailBlast/EmailCampaignDetails"));
// Engagement Hub (JOB-3305) — Phase 2 ships Contacts; later phases add Templates,
// Campaigns, Promo Codes, Analytics, Lead Capture under the same nav group.
const EngagementContactsList = React.lazy(() =>
  import("./Views/Admin/Engagement/Contacts/ContactsList")
);
const EngagementTemplatesList = React.lazy(() =>
  import("./Views/Admin/Engagement/Templates/EmailTemplatesList")
);
const EngagementTemplateEditor = React.lazy(() =>
  import("./Views/Admin/Engagement/Templates/TemplateEditor")
);
const EngagementPromoCodesList = React.lazy(() =>
  import("./Views/Admin/Engagement/PromoCodes/PromoCodesList")
);
const EngagementCampaignsList = React.lazy(() =>
  import("./Views/Admin/Engagement/Campaigns/EngagementCampaignsList")
);
const EngagementCampaignComposer = React.lazy(() =>
  import("./Views/Admin/Engagement/Campaigns/CampaignComposer")
);
const EngagementAnalyticsOverview = React.lazy(() =>
  import("./Views/Admin/Engagement/Analytics/AnalyticsOverview")
);
const EngagementCampaignAnalyticsView = React.lazy(() =>
  import("./Views/Admin/Engagement/Analytics/CampaignAnalyticsView")
);
const EngagementLeadCaptureSettings = React.lazy(() =>
  import("./Views/Admin/Engagement/LeadCapture/LeadCaptureSettings")
);
const FirstTimeNewPassword = React.lazy(() => import("./Views/StaffMember/FirstTimeNewPassword"));
const TimeTracking = React.lazy(() => import("./Views/StaffMember/TimeTracking/index"));
const StaffTimeEntryDetail = React.lazy(() => import("./Views/StaffMember/TimeTracking/StaffTimeEntryDetail"));
const Accountsetting = React.lazy(() => import("./Views/Admin/Setting/Accounts/Account.jsx"));
const ManageVisit = React.lazy(() => import("./Views/Admin/Setting/Manage Visits/ManageVisit.jsx"));
const CompanySetting = React.lazy(() => import("./Views/Admin/Setting/Company Setting/Index.jsx"));
const WorkerAppointments = React.lazy(() => import("./Views/StaffMember/Appoiment/Index"));
import PaymentBlues from "./assets/Blue-sidebar-icon/payment_leger.svg";
import ConfirmAppointment from "./Views/StaffMember/Appoiment/AppoimentConformation";
import WorkerSchedual from "./Views/StaffMember/Schedule/index";
import Theme from "./Views/Admin/Setting/Theme/Theme";
import CustomerPortalTheme from "./Views/Shared/CustomerPortalTheme";
import StaffPortalTheme from "./Views/Shared/StaffPortalTheme";
import SuperAdminPortalTheme from "./Views/Shared/SuperAdminPortalTheme";
import InvoiceDetailsClient from "./Views/Customer/Invoice/InvoiceDetails";
import MakePayment from "./Views/Admin/Make Payment/Index.jsx";
import AddNewEmail from "./Views/Admin/Communications/Send E-mail/SendNewEmail";
import PermissionSteps from "./Views/Superadmin/PermissionSteps/AddPermision";
import Permission from "./Views/Superadmin/PermissionSteps/Permission";
import CompanySchedual from "./Views/Admin/Schedual/Schedual/index";
import Invoice from "./Views/Admin/Invoice/Invoice";
import AddInvoice from "./Views/Admin/Invoice/AddInvoice";
import PlanPurchase from "./Views/Admin/Plan/PlanPurchase";
import InvoiceTable from "./Views/Admin/Invoice/InvoiceTable";
import InvoiceDetails from "./Views/Admin/Invoice/InvoiceDetails";
import Account from "./Views/Admin/Account/index";
import Email from "./Views/Superadmin/Mail service/index";
import SupportSettings from "./Views/Superadmin/SupportSettings/Index";
import ServerLogs from "./Views/Superadmin/ServerLogs/Index";
import BusinessDate from "./Views/Superadmin/BusinessDate/Index";
import ContracrClient from "./Views/Customer/Contract/Contract";
import ContracrDetailsClient from "./Views/Customer/Contract/ContractDetails";
import InvoiceClient from "./Views/Customer/Invoice/Invoice";
import Appoiments from "./Views/Customer/Appoiment/Index";
import AppoimentConformation from "./Views/Customer/Appoiment/AppoimentConformation";
import TodaysAppointments from "./Views/Shared/TodaysAppointments/Index";
import DateFormat from "./Views/Admin/Setting/Date Format/DateFormat";
import DateTimeFormat from "./Views/Admin/Setting/Date & Time Format/DateTimeFormat";
import NameFormat from "./Views/Admin/Setting/Name Format/NameFormat";
import TimeFormat from "./Views/Admin/Setting/Time Format/TimeFormat";
import Timezone from "./Views/Admin/Setting/Timezone/Timezone";
import MakeDonation from "./Views/Donor/MakeDonation";
import RecurringPledges from "./Views/Donor/RecurringPledges/RecurringPledges";

const DonorReports = React.lazy(() => import("./Views/Donor/Reports/DonorReports.jsx"));
// JOB-3230: switches /reports based on tenant mode so contractor admins
// don't see donation/donor-specific report sections.
const ReportsRouter = React.lazy(() => import("./Views/Admin/Reports/ReportsRouter.jsx"));
const DonationSummaryReport = React.lazy(() => import("./Views/Donor/Reports/DonationSummaryReport"));
const DonorTransactionReport = React.lazy(() => import("./Views/Donor/Reports/DonorTransactionReport"));
const DonorRetentionReport = React.lazy(() => import("./Views/Donor/Reports/DonorRetentionReport"));
const MajorGiftsReport = React.lazy(() => import("./Views/Donor/Reports/MajorGiftsReport"));
const RecurringDonorsReport = React.lazy(() => import("./Views/Donor/Reports/RecurringDonorsReport"));
const ExecutiveSummaryReport = React.lazy(() => import("./Views/Donor/Reports/ExecutiveSummaryReport"));
const DonorFailedTransactionReport = React.lazy(() => import("./Views/Donor/Reports/DonorFailedTransactionReport"));
const DonorVoidTransactionReport = React.lazy(() => import("./Views/Donor/Reports/DonorVoidTransactionReport"));
const DonorRefundTransactionReport = React.lazy(() => import("./Views/Donor/Reports/DonorRefundTransactionReport"));
const DonorPaymentSuccessFailureReport = React.lazy(() => import("./Views/Donor/Reports/DonorPaymentSuccessFailureReport"));

const JobReports = React.lazy(() => import("./Views/Admin/Reports/Views/JobReports"));
const JobTransactionHistory = React.lazy(() => import("./Views/Admin/Reports/Views/JobTransactionHistory"));
const JobFailedTransactionHistory = React.lazy(() => import("./Views/Admin/Reports/Views/JobFailedTransactionHistory"));
const JobRecurringPaymentReport = React.lazy(() => import("./Views/Admin/Reports/Views/JobRecurringPaymentReport"));
const JobFailedRecurringPayment = React.lazy(() => import("./Views/Admin/Reports/Views/JobFailedRecurringPayment"));
const JobTransactionBatchReport = React.lazy(() => import("./Views/Admin/Reports/Views/JobTransactionBatchReport"));
const RefundTransactionHistory = React.lazy(() => import("./Views/Admin/Reports/Views/RefundTransactionHistory"));
const VoidTransactionHistory = React.lazy(() => import("./Views/Admin/Reports/Views/VoidTransactionHistory"));
const PaymentSuccessFailureReport = React.lazy(() => import("./Views/Admin/Reports/Views/PaymentSuccessFailureReport"));
const LaborHoursReport = React.lazy(() => import("./Views/Admin/Reports/Views/LaborHoursReport"));

const LogoSetting = React.lazy(() => import("./Views/Admin/Setting/Logo setting/Logo-setting"));
const DonationLinkSetting = React.lazy(() => import("./Views/Admin/Setting/DonationLink/DonationLink"));
const PointOfSale = React.lazy(() => import("./Views/Admin/POS/PointOfSale"));
const AcceptDonation = React.lazy(() => import("./Views/Admin/POS/AcceptDonation"));

// Admin sidebar icons
import DashboardBlue from "./assets/Blue-sidebar-icon/Home.svg";
import DashboardWhite from "./assets/White-sidebar-icon/Home.svg";
import ScheduleBlue from "./assets/Blue-sidebar-icon/Schedule.svg";
import ScheduleWhite from "./assets/White-sidebar-icon/Schedule.svg";
import ClientBlue from "./assets/Blue-sidebar-icon/Customer.svg";
import ClientWhite from "./assets/White-sidebar-icon/Customer.svg";
import QuoteBlue from "./assets/Blue-sidebar-icon/Quote.svg";
import QuoteWhite from "./assets/White-sidebar-icon/Quote.svg";
import ContractBlue from "./assets/Blue-sidebar-icon/Contract.svg";
import ContractWhite from "./assets/White-sidebar-icon/Contract.svg";
import InvoiceBlue from "./assets/Blue-sidebar-icon/Invoice.svg";
import InvoiceWhite from "./assets/White-sidebar-icon/Invoice.svg";
import DonorLedgerBlue from "./assets/Blue-sidebar-icon/General-ledger.svg";
import DonorLedgerWhite from "./assets/White-sidebar-icon/General-ledger.svg";
import AppoinmentBlue from "./assets/Blue-sidebar-icon/Appoinment-blue.svg";
import AppoinmentWhite from "./assets/White-sidebar-icon/Appoinment-white.svg";

// import PaymentBlue from "./assets/Orange-icons/payment.svg";
import PaymentWhite from "./assets/White-sidebar-icon/Payment.svg";
import TemaplateWhite from "./assets/White-sidebar-icon/Templates.svg";
import TemplateBlue from "./assets/Blue-sidebar-icon/Templates.svg";
import EmailLogsWhite from "./assets/White-sidebar-icon/E-mail-Logs.svg";
import EmailLogsBlue from "./assets/Blue-sidebar-icon/E-mail-Logs.svg";
import EmailCampaignWhite from "./assets/White-sidebar-icon/Send E-Mail.svg";
import EmailCampaignBlue from "./assets/Blue-sidebar-icon/Send E-Mail.svg";
import ReportBlue from "./assets/Blue-sidebar-icon/Report.svg";
import ReportWhite from "./assets/White-sidebar-icon/Report.svg";
import NoteBlue from "./assets/Blue-sidebar-icon/Notes-blue.svg";
import NoteWhite from "./assets/White-sidebar-icon/Notes-white.svg";
import MakePaymentBlue from "./assets/Blue-sidebar-icon/Make-Payment.svg";
import MakePaymentWhite from "./assets/White-sidebar-icon/Make-Payment.svg";
import POSBlue from "./assets/Blue-sidebar-icon/POS.svg";
import POSWhite from "./assets/White-sidebar-icon/POS.svg";

// Superadmin Sidebar Icons
import PlanBlue from "./assets/Blue-sidebar-icon/Plan.svg";
import PlanWhite from "./assets/White-sidebar-icon/Plan.svg";
import CompanyBlue from "./assets/Blue-sidebar-icon/Company.svg";
import CompanyWhite from "./assets/White-sidebar-icon/Company.svg";
import ProductBlue from "./assets/Blue-sidebar-icon/Product & Services.svg";
import ProductWhite from "./assets/White-sidebar-icon/Product & Services.svg";
import PermissionBlue from "./assets/Blue-sidebar-icon/Permission.svg";
import PermissionWhite from "./assets/White-sidebar-icon/Permission.svg";
import EmailBlue from "./assets/Blue-sidebar-icon/Mail Service.svg";
import EmailWhite from "./assets/White-sidebar-icon/Mail Service.svg";
import EmailSidebarBlue from "./assets/Blue-sidebar-icon/Email-sidebar.svg";
import EmailSidebarWhite from "./assets/White-sidebar-icon/Email-sidebar.svg";
import SlackBlue from "./assets/Blue-sidebar-icon/Slack.svg";
import SlackWhite from "./assets/White-sidebar-icon/Slack.svg";
const InvoicePayment = React.lazy(() => import("./Views/Admin/Invoice/InvoicePayment"));
const EmployeeHours = React.lazy(() => import("./Views/Admin/EmployeeHours/EmployeeHours"));
const WorkerHoursDetail = React.lazy(() => import("./Views/Admin/EmployeeHours/WorkerHoursDetail"));
const SlackConfiguration = React.lazy(() => import("./Views/Superadmin/SlackService/index"));
const GeneralLeager = React.lazy(() => import("./Views/Donor/GeneralLedger/DonorGeneralLedger.jsx"));
import GeneralLedgerBlue from "./assets/Blue-sidebar-icon/General-ledger.svg";
import GeneralLedgerWhite from "./assets/White-sidebar-icon/General-ledger.svg";
const CustomerSchedule = React.lazy(() => import("./Views/Customer/Schedule/index"));
import IndustryWhite from "./assets/White-sidebar-icon/Industry-white.svg";
import IndustryBlue from "./assets/Blue-sidebar-icon/Industry-blue.svg";
import RevenueWhite from "./assets/White-sidebar-icon/Revenue-white.svg";
import RevenueBlue from "./assets/Blue-sidebar-icon/Revenue-blue.svg";
import TeamSizeWhite from "./assets/White-sidebar-icon/Team-white.svg";
import TeamSizeBlue from "./assets/Blue-sidebar-icon/Team-blue.svg";
import ManageTeamWhite from "./assets/White-sidebar-icon/Team-white.svg";
import ManageTeamBlue from "./assets/Blue-sidebar-icon/Team-blue.svg";
// Logs
const Activity = React.lazy(() => import("./Views/Admin/Activity/Index"));
const CustomerPayment = React.lazy(() => import("./Views/Customer/Invoice/CustomerPayment/CustomerPayment"));
const Surcharge = React.lazy(() => import("./Views/Admin/Setting/Manage Surcharge/Surcharge.jsx"));
const TransactionSettings = React.lazy(() => import("./Views/Admin/Setting/TransactionSettings/TransactionSettings"));
const BatchSettings = React.lazy(() => import("./Views/Admin/Setting/BatchSettings/BatchSettings.jsx"));
// NY surcharge commit 4eccd43bb — disclaimer settings page, lazy-loaded to match our code-split pattern
const Disclaimer = React.lazy(() => import("./Views/Admin/Setting/Disclaimer/Disclaimer.jsx"));
const PaymentTerminalIndex = React.lazy(() => import("./Views/Admin/Setting/PaymentTerminal"));
const ManageTaxes = React.lazy(() => import("./Views/Admin/Setting/Taxes/ManageTaxes"));
const ContactSupport = React.lazy(() => import("./Views/Admin/ContactSupport/ContactSupport"));
const CompanyDetails = React.lazy(() => import("./Views/Superadmin/Company/CompanyDetail"));

// Donor
const DonorDashboard = React.lazy(() => import("./Views/Dashboard/Donor"));
const DonorGeneralLedger = React.lazy(() => import("./Views/Donor/GeneralLedger/DonorGeneralLedger.jsx"));
const DonorProfile = React.lazy(() => import("./Views/Admin/Setting/Profile/DonorProfile.jsx"));
const Notes = React.lazy(() => import("./Views/Customer/Notes/Notes.jsx"));
const NotesDonor = React.lazy(() => import("./Views/Donor/Notes/Notes.jsx"));
const Industry = React.lazy(() => import("./Views/Industry/index.jsx"));
const Revenue = React.lazy(() => import("./Views/Revenue/index.jsx"));
const TeamSize = React.lazy(() => import("./Views/TeamSize/index.jsx"));
var routes = [
  // =============== AUTH ===============
  {
    path: "/login",
    name: "Login",
    component: <Login />,
    layout: "/auth",
    isDisplay: true,
  },
  {
    path: "/signup",
    name: "Sign-Up",
    component: <SignUp />,
    layout: "/auth",
    isDisplay: true,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: <ForgotPassword />,
    layout: "/auth",
    isDisplay: true,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: <NewPassword />,
    layout: "/auth",
    isDisplay: true,
  },
  {
    path: "/new-password?email",
    name: "New Password",
    component: <NewPassword />,
    layout: "/auth",
    isDisplay: true,
  },
  {
    path: "/new-password",
    name: "New Password",
    component: <ResetPassword />,
    layout: "/auth",
    isDisplay: true,
  },
  {
    path: "/firsttimenewpassword",
    name: "FirstTimeNewPassword",
    icon: <HomeRoundedIcon />,
    component: <FirstTimeNewPassword />,
    layout: "/auth",
  },
  // =============== SUPER ADMIN ===============
  {
    path: "/index",
    name: "Dashboard",
    icon: <img src={DashboardWhite} alt="Dashboard" />,
    icon2: <img src={DashboardBlue} alt="Dashboard" />,
    component: <SuperadminDashboard />,
    layout: "/superadmin",
    isDisplay: true,
    module: "superadmin",
  },
  {
    path: "/SuperAdminProfile",
    name: "SuperAdminProfile",
    component: <SuperAdminProfile />,
    layout: "/superadmin",
    isDisplay: false,
    module: "Setting",
  },
  {
    path: "/settings/theme",
    name: "Theme",
    component: <SuperAdminPortalTheme />,
    layout: "/superadmin",
    isDisplay: false,
    module: "Setting",
  },
  {
    path: "/plan",
    name: "Plans",
    icon: <img src={PlanWhite} alt="Plans" />,
    icon2: <img src={PlanBlue} alt="Plans" />,
    component: <SuperadminPlan />,
    layout: "/superadmin",
    isDisplay: true,
    module: "Plan",
  },

  {
    path: "/company",
    name: "Companies",
    icon: <img src={CompanyWhite} alt="Companies" />,
    icon2: <img src={CompanyBlue} alt="Companies" />,
    component: <Company />,
    layout: "/superadmin",
    isDisplay: true,
    module: "Company",
  },
  {
    path: "/company-detail",
    name: "Company Details",
    component: <CompanyDetail />,
    layout: "/superadmin",
    isDisplay: false,
    module: "Company",
  },
  {
    path: "/superadmin-management",
    name: "Super Admins ",
    icon: <img src={PermissionWhite} alt="Super Admin " />,
    icon2: <img src={PermissionBlue} alt="Super Admin " />,
    component: <SuperAdminManagement />,
    layout: "/superadmin",
    isDisplay: true,
    module: "Super Admin ",
  },
  {
    path: "/materials-labor",
    name: "Materials & Labor",
    icon: <img src={ProductWhite} alt="Materials & Labor" />,
    icon2: <img src={ProductBlue} alt="Materials & Labor" />,
    component: <MaterialsAndLaborSuperadmin />,
    layout: "/superadmin",
    isDisplay: true,
    module: "Materials & Labor",
  },
  {
    path: "/add-permission",
    name: "Add Permission",
    icon: <MonetizationOnOutlinedIcon />,
    component: <PermissionSteps />,
    layout: "/superadmin",
    isDisplay: false,
    module: "Permissions",
  },
  {
    path: "/permission",
    name: "Permissions",
    icon: (
      <LockOutlinedIcon
        sx={{ color: "#fff", fontSize: 22, width: 22, height: 22 }}
      />
    ),
    icon2: (
      <LockOutlinedIcon
        sx={{ color: "#0f2b46", fontSize: 22, width: 22, height: 22 }}
      />
    ),
    component: <Permission />,
    layout: "/superadmin",
    isDisplay: true,
    module: "Permissions",
  },
  {
    path: "/email",
    name: "Mail Service",
    component: <Email />,
    icon: <img src={EmailWhite} alt="Mail Service" />,
    icon2: <img src={EmailBlue} alt="Mail Service" />,
    layout: "/superadmin",
    isDisplay: true,
  },
  // {
  //   path: "/business-date",
  //   name: "Business Date",
  //   component: <BusinessDate />,
  //   icon: (
  //     <CalendarTodayIcon
  //       style={{
  //         fontSize: "20px",
  //         color: "#fff",
  //         width: "20px",
  //         height: "20px",
  //       }}
  //     />
  //   ),
  //   icon2: (
  //     <CalendarTodayIcon
  //       style={{
  //         fontSize: "20px",
  //         color: "#0f2b46",
  //         width: "20px",
  //         height: "20px",
  //       }}
  //     />
  //   ),
  //   layout: "/superadmin",
  //   isDisplay: true,
  //   module: "Settings",
  // },
  // {
  //   path: "/support-settings",
  //   name: "Support",
  //   component: <SupportSettings />,
  //   icon: <HelpOutlineIcon style={{ color: "white" }} />,
  //   icon2: <HelpOutlineIcon style={{ color: "#0f2b46" }} />,
  //   layout: "/superadmin",
  //   isDisplay: true,
  // },
  {
    path: "/server-logs",
    name: "Server Logs",
    component: <ServerLogs />,
    icon: <DescriptionIcon style={{ color: "white" }} />,
    icon2: <DescriptionIcon style={{ color: "#0f2b46" }} />,
    layout: "/superadmin",
    isDisplay: true,
  },
  // ======================== Industry Type (Direct Menu Item) ======================
  {
    path: "/industry",
    name: "Industry Type",
    layout: "/superadmin",
    icon: <img src={IndustryWhite} alt="Industry Type" />,
    icon2: <img src={IndustryBlue} alt="Industry Type" />,
    component: <Industry />,
    isDisplay: true,
    module: "Industry Type",
  },
  // {
  //   path: "/revenue",
  //   name: "Revenue",
  //   layout: "/superadmin",
  //   icon: <img src={RevenueWhite} alt="Revenue" />,
  //   icon2: <img src={RevenueBlue} alt="Revenue" />,
  //   component: <Revenue />,
  //   isDisplay: true,
  //   module: "Revenue",
  //   isCollapse: false,
  // },
  // {
  //   path: "/team-size",
  //   name: "Team Size",
  //   layout: "/superadmin",
  //   icon: <img src={TeamSizeWhite} alt="Team Size" />,
  //   icon2: <img src={TeamSizeBlue} alt="Team Size" />,
  //   component: <TeamSize />,
  //   isDisplay: true,
  //   module: "Team Size",
  //   isCollapse: false,
  // },
  // {
  //   path: "/slack-configuration",
  //   name: "Slack Service",
  //   component: <SlackConfiguration />,
  //   icon: <img src={SlackWhite} alt="Slack Service" />,
  //   icon2: <img src={SlackBlue} alt="Slack Service" />,
  //   layout: "/superadmin",
  //   isDisplay: true,
  // },
  {
    path: "/email-settings",
    name: "Email Settings",
    icon: <CategoryOutlinedIcon />,
    component: <EmailSettings />,
    layout: "/superadmin",
    isDisplay: false,
    module: "Email Settings",
  },
  // {
  //   path: "/invoice-settings",
  //   name: "Invoice Settings",
  //   icon: <CategoryOutlinedIcon />,
  //   component: <InvoiceSettings />,
  //   layout: "/superadmin",
  //   isDisplay: false,
  //   module: "Invoice Settings",
  // },
  {
    path: "/contact-support",
    name: "Contact Support",
    component: <ContactSupport />,
    layout: "/superadmin",
    isDisplay: false,
    module: "Contact Support",
  },
  // =============== COMPANY ===============
  {
    // JOB-3231: canonicalize on `/settings` (plural) — matches user-menu
    // label, sidebar text, and browser tab title. Keeping `/setting`
    // (singular) as a sibling alias so existing bookmarks keep working.
    path: "/settings",
    name: "Settings",
    icon: <img src={client} alt="Settings" />,
    component: <Setting />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Settings",
  },
  {
    // JOB-3231 legacy alias — redirect target would be ideal but the routes
    // config doesn't support redirects; mounting the same component keeps
    // old bookmarks working with the (now-legacy) tab title.
    path: "/setting",
    name: "Settings",
    icon: <img src={client} alt="Settings" />,
    component: <Setting />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Settings",
  },
  {
    path: "/add-user",
    name: "Add User",
    icon: <img src={client} alt="Add User" />,
    component: <AddUser />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Setting",
  },
  {
    path: "/account-billing",
    name: "Account",
    component: <Account />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Account",
  },
  {
    path: "/worker-details",
    name: "Worker Details",
    icon: <CategoryOutlinedIcon />,
    component: <WorkerDetail />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Setting",
  },
  {
    path: "/manage-template",
    name: "Manage Templates",
    icon: <CategoryOutlinedIcon />,
    component: <ManageTemplates />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Manage Templates",
  },
  {
    path: "/email-settings",
    name: "Email Settings",
    icon: <CategoryOutlinedIcon />,
    component: <EmailSettings />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Email Settings",
  },
  {
    path: "/invoice-settings",
    name: "Invoice Settings",
    icon: <CategoryOutlinedIcon />,
    component: <InvoiceSettings />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Invoice Settings",
  },
  {
    path: "/taxes",
    name: "Taxes",
    icon: <CategoryOutlinedIcon />,
    component: <ManageTaxes />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Taxes",
    parent: "/setting",
  },
  {
    path: "/manage-visits",
    name: "Manage visits",
    icon: <CategoryOutlinedIcon />,
    component: <ManageVisit />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Manage visits",
  },
 

  {
    path: "/contract-details",
    name: "Contract-Details",
    component: <ContractDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Contract",
  },
  {
    path: "/userdetails",
    name: "User Details",
    component: <UserDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Setting",
  },
  // {
  //   path: "/index",
  //   name: "Home",
  //   icon: <img src={DashboardWhite} />,
  //   icon2: <img src={DashboardBlue} />,
  //   component: <AdminDashboard />,
  //   layout: "/:CompanyUrl",
  //   isDisplay: true,
  //   module: "Home",
  // },
  {
    path: "/index",
    name: "Dashboard",
    icon: <img src={DashboardWhite} alt="Dashboard" />,
    icon2: <img src={DashboardBlue} alt="Dashboard" />,
    component: <AdminDashboard />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "superadmin",
  },
  {
    path: "/accept-donation",
    name: "Accept Donation",
    icon: <img src={POSWhite} alt="Accept Donation" />,
    icon2: <img src={POSBlue} alt="Accept Donation" />,
    component: <AcceptDonation />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Accept Donation",
  },
  {
    path: "/schedule",
    name: "Schedule",
    icon: <img src={ScheduleWhite} alt="Schedule" />,
    icon2: <img src={ScheduleBlue} alt="Schedule" />,
    component: <CompanySchedual />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Schedule",
  },
  {
    path: "/todays-appointments",
    name: "Today's Appointments",
    icon: <img src={AppoinmentWhite} alt="Today's Appointments" />,
    icon2: <img src={AppoinmentBlue} alt="Today's Appointments" />,
    component: <TodaysAppointments />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Schedule",
  },

  {
    path: "/customer",
    name: "Customers",
    icon: <img src={ClientWhite} alt="Customers" />,
    icon2: <img src={ClientBlue} alt="Customers" />,
    component: <Client />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Customer",
  },
  {
    path: "/donor",
    name: "Donor List",
    icon: <img src={ClientWhite} alt="Donor List" />,
    icon2: <img src={ClientBlue} alt="Donor List" />,
    component: <Client />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Donor",
  },
  {
    path: "/quotesdetail",
    name: "Quotes",
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Quote",
  },
  {
    path: "/materials-labor",
    name: "Materials & Labor",
    icon: <img src={ProductWhite} alt="Materials & Labor" />,
    icon2: <img src={ProductBlue} alt="Materials & Labor" />,
    component: <MaterialsLabor />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Materials & Labor",
  },
  {
    path: "/manageteam",
    name: "Manage Team",
    icon: <img src={ManageTeamWhite} alt="Manage Team" />,
    icon2: <img src={ManageTeamBlue} alt="Manage Team" />,
    component: <ManageTeamTable />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Setting",
  },
  {
    path: "/quotes",
    name: "Quotes",
    icon: <img src={QuoteWhite} alt="Quotes" />,
    icon2: <img src={QuoteBlue} alt="Quotes" />,
    component: <Quotes />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Quote",
  },
  {
    path: "/service-requests",
    name: "Requests",
    icon: <img src={NoteWhite} alt="Requests" />,
    icon2: <img src={NoteBlue} alt="Requests" />,
    component: <ServiceRequestsPage />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Requests",
  },
  {
    path: "/service-request-detail",
    name: "Request Detail",
    component: <ServiceRequestDetail />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Requests",
  },
  {
    path: "/add-service-requests",
    name: "Add Request",
    component: <AddServiceRequest />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Requests",
  },
  {
    path: "/add-customer",
    name: "Add Customer",
    icon: <img src={ContractWhite} alt="Add Customer" />,
    icon2: <img src={ContractBlue} alt="Add Customer" />,
    component: <AddClient />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/edit-customer/:id",
    name: "Edit Customer",
    icon: <img src={ContractWhite} alt="Edit Customer" />,
    icon2: <img src={ContractBlue} alt="Edit Customer" />,
    component: <AddClient />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/add-donors",
    name: "Add Donors",
    icon: <img src={ContractWhite} alt="Add Donors" />,
    icon2: <img src={ContractBlue} alt="Add Donors" />,
    component: <AddClient />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Donor",
  },
  {
    path: "/plan-purchase",
    name: "Plan Purchase",
    component: <PlanPurchase />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Account",
  },
  {
    path: "/add-contract",
    name: "Add Contract",
    icon: <img src={client} alt="Add Contract" />,
    component: <AddContract />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Contract",
  },
  {
    path: "/add-quotes",
    name: "Add Quotes",
    icon: <SentimentSatisfiedOutlinedIcon />,
    component: <Addquotes />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Quote",
  },
  {
    path: "/quotes-detail",
    name: "Quote Details",
    icon: <SentimentSatisfiedOutlinedIcon />,
    component: <QuotesDetail />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Quote",
  },
  {
    path: "/property-details",
    name: "Property Details",
    component: <PropertyDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/donor-property-details",
    name: "Donor Property Details",
    component: <PropertyDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Donors",
  },
  {
    path: "/contract",
    name: "Contracts",
    icon: <img src={ContractWhite} alt="Contracts" />,
    icon2: <img src={ContractBlue} alt="Contracts" />,
    component: <Job />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Contract",
  },
  {
    path: "/plan",
    name: "Plan",
    icon: <MonetizationOnOutlinedIcon />,
    icon2: <MonetizationOnOutlinedIcon />,
    component: <Plan />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Account",
  },
  {
    path: "/customerdetails",
    name: "Customer Details",
    component: <ClientDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/donordetails",
    name: "Donor Details",
    component: <ClientDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Donors",
  },

  {
    path: "/profile",
    name: "Profile",
    component: <Profile />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Setting",
  },

  {
    path: "/invoice",
    name: "Invoices",
    icon: <img src={InvoiceWhite} alt="Invoice" />,
    icon2: <img src={InvoiceBlue} alt="Invoice" />,
    component: <Invoice />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Invoice",
  },
  {
    path: "/addinvoice",
    name: "Add Invoice",
    component: <AddInvoice />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/invoicetable",
    name: "Invoice Table",
    component: <InvoiceTable />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/invoice-details",
    name: "Invoice Details",
    component: <InvoiceDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/invoice-payment",
    name: "Invoice Payment",
    component: <InvoicePayment />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/employee-hours",
    name: "Worker Hours",
    icon: <AccessTimeIcon style={{ color: "white" }} />,
    icon2: <AccessTimeIcon style={{ color: "#0f2b46" }} />,
    component: <EmployeeHours />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Worker Hours",
  },
  {
    path: "/employee-hours/detail",
    name: "Worker Hours Detail",
    component: <WorkerHoursDetail />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Worker Hours",
  },
  {
    path: "/pos",
    name: "POS",
    icon: <img src={POSWhite} alt="POS" />,
    icon2: <img src={POSBlue} alt="POS" />,
    component: <PointOfSale />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "POS",
  },
  {
    path: "/contact-support",
    name: "Contact Support",
    component: <ContactSupport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Contact Support",
  },
  // {
  //   path: "/google-maps-demo",
  //   name: "Address",
  //   icon: <LocationOnIcon sx={{ color: '#fff' }} />,
  //   icon2: <LocationOnIcon sx={{ color: '#2563eb' }} />,
  //   component: <GoogleMapsDemo />,
  //   layout: "/:CompanyUrl",
  //   isDisplay: true,
  //   module: "Google Maps",
  // },
  // ======================== Dropdown sidebar ======================
  {
    name: "Email",
    layout: "/:CompanyUrl",
    icon: (
      <img
        src={EmailSidebarWhite}
        alt="Email"
        width={18}
        height={19}
        style={{ display: "block", flexShrink: 0 }}
      />
    ),
    icon2: (
      <img
        src={EmailSidebarBlue}
        alt="Email"
        width={18}
        height={19}
        style={{ display: "block", flexShrink: 0 }}
      />
    ),
    isCollapse: true,
    module: "Templates",
    isDisplay: true,
    children: [
      {
        path: "/templates",
        name: "Templates",
        layout: "/:CompanyUrl",
        icon: <img src={TemaplateWhite} alt="Templates" />,
        icon2: <img src={TemplateBlue} alt="Templates" />,
        component: <Templates />,
        isDisplay: true,
        module: "Templates",
        isCollapse: false,
      },
      {
        path: "/Email-logs",
        name: "Email Logs",
        layout: "/:CompanyUrl",
        icon: <img src={EmailLogsWhite} alt="Email Logs" />,
        icon2: <img src={EmailLogsBlue} alt="Email Logs" />,
        component: <EmailLogs />,
        isDisplay: true,
        module: "Templates",
        isCollapse: false,
      },
      {
        path: "/email-campaign",
        name: "Email Campaign",
        layout: "/:CompanyUrl",
        icon: <img src={EmailCampaignWhite} alt="Email Campaign" />,
        icon2: <img src={EmailCampaignBlue} alt="Email Campaign" />,
        component: <EmailCampaignList />,
        isDisplay: true,
        module: "Templates",
        isCollapse: false,
      },
      // {
      //   path: "/send-email",
      //   name: "Send E-mail",
      //   layout: "/:CompanyUrl",
      //   icon: <img src={SendEmailWhite} />,
      //   icon2: <img src={SendEmailBlue} />,
      //   component: <SendEmail />,
      //   isDisplay: true,
      //   module: "Templates",
      //   isCollapse: false,
      // },
    ],
  },
  // ======================== Engagement Hub (JOB-3305) ============
  // Phase 2 ships Contacts. Future phases add Templates, Campaigns,
  // Promo Codes, Analytics, Lead Capture under this same group.
  {
    name: "Engagement",
    layout: "/:CompanyUrl",
    icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
    icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
    isCollapse: true,
    module: "Engagement",
    isDisplay: true,
    children: [
      {
        path: "/engagement/contacts",
        name: "Contacts",
        layout: "/:CompanyUrl",
        icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
        icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
        component: <EngagementContactsList />,
        isDisplay: true,
        module: "Engagement",
        isCollapse: false,
      },
      {
        path: "/engagement/templates",
        name: "Templates",
        layout: "/:CompanyUrl",
        icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
        icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
        component: <EngagementTemplatesList />,
        isDisplay: true,
        module: "Engagement",
        isCollapse: false,
      },
      {
        path: "/engagement/promo-codes",
        name: "Promo Codes",
        layout: "/:CompanyUrl",
        icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
        icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
        component: <EngagementPromoCodesList />,
        isDisplay: true,
        module: "Engagement",
        isCollapse: false,
      },
      {
        path: "/engagement/campaigns",
        name: "Campaigns",
        layout: "/:CompanyUrl",
        icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
        icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
        component: <EngagementCampaignsList />,
        isDisplay: true,
        module: "Engagement",
        isCollapse: false,
      },
      {
        path: "/engagement/analytics",
        name: "Analytics",
        layout: "/:CompanyUrl",
        icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
        icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
        component: <EngagementAnalyticsOverview />,
        isDisplay: true,
        module: "Engagement",
        isCollapse: false,
      },
      {
        path: "/engagement/lead-capture",
        name: "Lead Capture",
        layout: "/:CompanyUrl",
        icon: <CampaignOutlinedIcon style={{ color: "#fff" }} />,
        icon2: <CampaignOutlinedIcon style={{ color: "#1d4ed8" }} />,
        component: <EngagementLeadCaptureSettings />,
        isDisplay: true,
        module: "Engagement",
        isCollapse: false,
      },
    ],
  },
  // Hidden: Campaign composer (deep-link from Campaigns list).
  {
    path: "/engagement/campaigns/:campaignId",
    name: "Compose Campaign",
    layout: "/:CompanyUrl",
    component: <EngagementCampaignComposer />,
    isDisplay: false,
    module: "Engagement",
  },
  // Hidden: Per-campaign analytics deep-link from list.
  {
    path: "/engagement/campaigns/:campaignId/analytics",
    name: "Campaign Analytics",
    layout: "/:CompanyUrl",
    component: <EngagementCampaignAnalyticsView />,
    isDisplay: false,
    module: "Engagement",
  },
  // Hidden: Template editor (deep-link from Templates list).
  {
    path: "/engagement/templates/:templateId",
    name: "Edit Template",
    layout: "/:CompanyUrl",
    component: <EngagementTemplateEditor />,
    isDisplay: false,
    module: "Engagement",
  },
  {
    path: "/reports",
    name: "Reports",
    icon: <img src={ReportWhite} alt="Reports" />,
    icon2: <img src={ReportBlue} alt="Reports" />,
    // JOB-3230: ReportsRouter picks DonorReports vs JobReports based on
    // tenant mode. Previously this was hardcoded to DonorReports, which
    // exposed donation/donor report sections to contractor admins.
    component: <ReportsRouter />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Reports",
  },
  {
    path: "/company-reports",
    name: "Reports",
    icon: <img src={ReportWhite} alt="Company Reports" />,
    icon2: <img src={ReportBlue} alt="Company Reports" />,
    component: <JobReports />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Reports",
  },
  {
    path: "/company-reports/transaction-history",
    name: "Transaction History",
    component: <JobTransactionHistory />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/failed-transaction-history",
    name: "Failed Transaction History",
    component: <JobFailedTransactionHistory />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/recurring-payment-report",
    name: "Recurring Payment Report",
    component: <JobRecurringPaymentReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/failed-recurring-payment-report",
    name: "Failed Recurring Payment Report",
    component: <JobFailedRecurringPayment />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/transaction-batch-report",
    name: "Transaction Batch Report",
    component: <JobTransactionBatchReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/refund-transaction-history",
    name: "Refund Transaction History",
    component: <RefundTransactionHistory />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/void-transaction-history",
    name: "Void Transaction History",
    component: <VoidTransactionHistory />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/payment-success-failure-report",
    name: "Payment Success/Failure Report",
    component: <PaymentSuccessFailureReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/company-reports/labor-hours-report",
    name: "Worker Hours Report",
    component: <LaborHoursReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/donation-summary",
    name: "Donation Summary Report",
    component: <DonationSummaryReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/executive-summary",
    name: "Executive Summary Report",
    component: <ExecutiveSummaryReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/transaction-report",
    name: "Donation Transaction Report",
    component: <DonorTransactionReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/failed-transaction-report",
    name: "Donation Failed Transaction Report",
    component: <DonorFailedTransactionReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/void-transaction-report",
    name: "Donor Void Transaction Report",
    component: <DonorVoidTransactionReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/refund-transaction-report",
    name: "Donor Refund Transaction Report",
    component: <DonorRefundTransactionReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/payment-success-failure-report",
    name: "Donation Success/Failure Report",
    component: <DonorPaymentSuccessFailureReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/retention-report",
    name: "Donation Retention Report",
    component: <DonorRetentionReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/major-gifts",
    name: "Major Gifts Report",
    component: <MajorGiftsReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/recurring-donors",
    name: "Recurring Donors Report",
    component: <RecurringDonorsReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/reports/transaction-batch-report",
    name: "Transaction Batch Report",
    component: <JobTransactionBatchReport />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Reports",
  },
  // =============== CUSTOMER ===============
  {
    path: "/add-quotes",
    name: "Add Quotes",
    icon: <SentimentSatisfiedOutlinedIcon />,
    component: <Addquotes />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Quote",
  },

  {
    path: "/profile",
    name: "Profile",
    component: <CustomerProfile />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Setting",
  },
  {
    path: "/settings/theme",
    name: "Theme",
    component: <CustomerPortalTheme />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Setting",
  },

  {
    path: "/index",
    name: "Dashboard",
    icon: <img src={DashboardWhite} alt="Dashboard" />,
    icon2: <img src={DashboardBlue} alt="Dashboard" />,
    component: <ClientDashboard />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "superadmin",
  },
  {
    path: "/add-customer",
    name: "Add Customer",
    icon: <img src={client} alt="Add Customer" />,
    component: <AddClient />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/edit-customer/:id",
    name: "Edit Customer",
    icon: <img src={client} alt="Edit Customer" />,
    component: <AddClient />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Customer",
  },

  {
    path: "/customer-service-requests",
    name: "Requests",
    icon: <img src={NoteWhite} alt="Requests" />,
    icon2: <img src={NoteBlue} alt="Requests" />,
    component: <ClientServiceRequests />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Requests",
  },
  {
    path: "/customer-service-request-detail",
    name: "Request Details",
    icon: <SentimentSatisfiedOutlinedIcon />,
    component: <ClientServiceRequestDetail />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Requests",
  },
  {
    path: "/quotes",
    name: "Quotes",
    icon: <img src={QuoteWhite} alt="Quotes" />,
    icon2: <img src={QuoteBlue} alt="Quotes" />,
    component: <ClientQuotes />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Quotes",
  },
  {
    path: "/quotes-details",
    name: "Quotes Details",
    icon: <SentimentSatisfiedOutlinedIcon />,
    component: <ClientQuotesdetail />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Quotes",
  },
  {
    path: "/contract",
    name: "Contracts",
    icon: <img src={ContractWhite} alt="Contracts" />,
    icon2: <img src={ContractBlue} alt="Contracts" />,
    component: <ContracrClient />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Contract",
  },
  {
    path: "/customer-schedule",
    name: "Schedule",
    icon: <img src={ScheduleWhite} alt="Schedule" />,
    icon2: <img src={ScheduleBlue} alt="Schedule" />,
    component: <CustomerSchedule />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Customer Schedule",
  },

  {
    path: "/contract-details",
    name: "Contract Details",
    icon: <img src={ContractWhite} alt="Contract Details" />,
    icon2: <img src={ContractBlue} alt="Contract Details" />,
    component: <ContracrDetailsClient />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Contract",
  },
  {
    path: "/invoice",
    name: "Invoices",
    icon: <img src={InvoiceWhite} alt="Invoices" />,
    icon2: <img src={InvoiceBlue} alt="Invoices" />,
    component: <InvoiceClient />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Invoice",
  },
  {
    path: "/invoice-details",
    name: "Invoice Details",
    icon: <img src={InvoiceWhite} alt="Invoice Details" />,
    icon2: <img src={InvoiceBlue} alt="Invoice Details" />,
    component: <InvoiceDetailsClient />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/invoice-payments",
    name: "Invoice Payments",
    icon: <img src={InvoiceWhite} alt="Invoice Payments" />,
    icon2: <img src={InvoiceBlue} alt="Invoice Payments" />,
    component: <CustomerPayment />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/General-ledger",
    name: "General Ledger ",
    icon: <img src={GeneralLedgerWhite} alt="General Leager" />,
    icon2: <img src={GeneralLedgerBlue} alt="General Leager" />,
    component: <GeneralLeager />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "General Ledger",
  },
  // {
  //   path: "/recurring-payment",
  //   name: "Recurring Payment",
  //   icon: <img src={PaymentWhite} />,
  //   icon2: <img src={PaymentBlues} />,
  //   component: <RecurringPayment />,
  //   layout: "/:CompanyUrl/customers",
  //   isDisplay: true,
  //   module: "Recurring Payment",
  // },

  {
    path: "/appointment",
    name: "Appointment",
    icon: <img src={AppoinmentWhite} alt="Appointment" />,
    icon2: <img src={AppoinmentBlue} alt="Appointment" />,
    component: <Appoiments />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Appointment",
  },
  {
    path: "/todays-appointments",
    name: "Today's Appointments",
    icon: <img src={AppoinmentWhite} alt="Today's Appointments" />,
    icon2: <img src={AppoinmentBlue} alt="Today's Appointments" />,
    component: <TodaysAppointments />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Appointment",
  },
  {
    path: "/appointment-confirm",
    name: "Confirm Appointment",
    icon: <img src={AppoinmentWhite} alt="Confirm Appointment" />,
    icon2: <img src={AppoinmentBlue} alt="Confirm Appointment" />,
    component: <AppoimentConformation />,
    layout: "/:CompanyUrl/customers",
    isDisplay: false,
    module: "Appointment",
  },
  {
    path: "/notes",
    name: "Notes",
    icon: <img src={NoteWhite} alt="Notes" />,
    icon2: <img src={NoteBlue} alt="Notes" />,
    component: <Notes />,
    layout: "/:CompanyUrl/customers",
    isDisplay: true,
    module: "Note",
  },

  // =============== STAFF MEMBER ===============
  {
    path: "/index",
    name: "Dashboard",
    icon: <img src={DashboardWhite} alt="Dashboard" />,
    icon2: <img src={DashboardBlue} alt="Dashboard" />,
    component: <StaffMember />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "superadmin",
  },




  {
    path: "/profile",
    name: "Profile",
    component: <StaffMemberProfile />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Setting",
  },
  {
    path: "/settings/theme",
    name: "Theme",
    component: <StaffPortalTheme />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Setting",
  },

  {
    path: "/add-customer",
    name: "Add Customer",
    icon: <img src={client} alt="Add Customer" />,
    component: <AddClient />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/edit-customer/:id",
    name: "Edit Customer",
    icon: <img src={client} alt="Edit Customer" />,
    component: <AddClient />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/customer-details",
    name: "Customer Detail",
    icon: <img src={client} alt="Customer Detail" />,
    component: <ClientDetails />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Customer",
  },
  {
    path: "/worker-schedule",
    name: "Schedule",
    icon: <img src={ScheduleWhite} alt="Schedule" />,
    icon2: <img src={ScheduleBlue} alt="Schedule" />,
    component: <WorkerSchedual />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Schedule",
  },
  {
    path: "/worker-customer",
    name: "Customers",
    icon: <img src={ClientWhite} alt="Customers" />,
    icon2: <img src={ClientBlue} alt="Customers" />,
    component: <Client />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Customer",
  },
  {
    path: "/worker-quote",
    name: "Quotes",
    icon: <img src={QuoteWhite} alt="Quotes" />,
    icon2: <img src={QuoteBlue} alt="Quotes" />,
    component: <Quotes />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Quote",
  },
  {
    path: "/worker-service-requests",
    name: "Requests",
    icon: <img src={NoteWhite} alt="Requests" />,
    icon2: <img src={NoteBlue} alt="Requests" />,
    component: <ServiceRequestsPage />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Requests",
  },
  {
    path: "/worker-service-request-detail",
    name: "Request Detail",
    component: <ServiceRequestDetail />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Requests",
  },
  {
    path: "/add-service-requests",
    name: "Add Request",
    component: <AddServiceRequest />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Requests",
  },
  {
    path: "/worker-materials-labor",
    name: "Materials & Labor",
    icon: <img src={ProductWhite} alt="Materials & Labor" />,
    icon2: <img src={ProductBlue} alt="Materials & Labor" />,
    component: <MaterialsLabor />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Materials & Labor",
  },
  {
    path: "/add-quotes",
    name: "Add Quotes",
    icon: <SentimentSatisfiedOutlinedIcon />,
    component: <Addquotes />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Quote",
  },
  {
    path: "/worker-quotes-details",
    name: "Quote Detail",
    icon: <img src={client} alt="Quote Detail" />,
    component: <QuotesDetail />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Quotes",
  },
  {
    path: "/worker-property-details",
    name: "Property Details",
    component: <PropertyDetails />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Customer",
  },

  {
    path: "/worker-contract",
    name: "Contracts",
    icon: <img src={ContractWhite} alt="Contracts" />,
    icon2: <img src={ContractBlue} alt="Contracts" />,
    component: <Job />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Contract",
  },
  {
    path: "/add-contract",
    name: "Add Contract",
    icon: <img src={client} alt="Add Contract" />,
    component: <AddContract />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Contract",
  },
  {
    path: "/worker-contract-details",
    name: "Contract Detail",
    icon: <img src={client} alt="Contract Detail" />,
    component: <ContractDetails />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Contract",
  },

  //2529 worker-invoice
  {
    path: "/worker-invoice",
    name: "Invoices",
    icon: <img src={InvoiceWhite} alt="Invoices" />,
    icon2: <img src={InvoiceBlue} alt="Invoices" />,
    component: <Invoice />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Invoice",
  },
  {
    path: "/addinvoice",
    name: "Add Invoice",
    icon: <img src={InvoiceWhite} alt="Add Invoice" />,
    icon2: <img src={InvoiceBlue} alt="Add Invoice" />,
    component: <AddInvoice />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Invoice",
  },
  {
    path: "/workerinvoicetable",
    name: "Invoice Table",
    component: <InvoiceTable />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Invoice",
  },

  {
    path: "/worker-invoice-detail",
    name: "Invoice Details",
    icon: <img src={InvoiceWhite} alt="Invoice Details" />,
    icon2: <img src={InvoiceBlue} alt="Invoice Details" />,
    component: <InvoiceDetails />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Invoice",
  },
  {
    path: "/invoice-payment",
    name: "Invoice Payment",
    component: <InvoicePayment />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Invoice",
  },

  {
    path: "/worker-appointments",
    name: "Appointment",
    icon: <img src={AppoinmentWhite} alt="Appointment" />,
    icon2: <img src={AppoinmentBlue} alt="Appointment" />,
    component: <WorkerAppointments />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Appointment",
  },
  {
    path: "/worker-todays-appointments",
    name: "Today's Appointments",
    icon: <img src={AppoinmentWhite} alt="Today's Appointments" />,
    icon2: <img src={AppoinmentBlue} alt="Today's Appointments" />,
    component: <TodaysAppointments />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Appointment",
  },
  {
    path: "/worker-time-entry",
    name: "Time Entry",
    icon: <AccessTimeIcon style={{ color: "#fff", fontSize: "24px" }} />,
    icon2: <AccessTimeIcon style={{ color: "#0f2b46", fontSize: "24px" }} />,
    component: <TimeTracking />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "TimeTracking",
  },
  {
    path: "/worker-time-entry/detail",
    name: "Time Entry Detail",
    component: <StaffTimeEntryDetail />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "TimeTracking",
  },
  {
    path: "/worker-reports",
    name: "Reports",
    icon: <img src={ReportWhite} alt="Reports" />,
    icon2: <img src={ReportBlue} alt="Reports" />,
    component: <JobReports />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: true,
    module: "Reports",
  },
  {
    path: "/worker-reports/transaction-history",
    name: "Transaction History",
    component: <JobTransactionHistory />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/failed-transaction-history",
    name: "Failed Transaction History",
    component: <JobFailedTransactionHistory />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/recurring-payment-report",
    name: "Recurring Payment Report",
    component: <JobRecurringPaymentReport />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/failed-recurring-payment-report",
    name: "Failed Recurring Payment Report",
    component: <JobFailedRecurringPayment />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/transaction-batch-report",
    name: "Transaction Batch Report",
    component: <JobTransactionBatchReport />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/void-transaction-history",
    name: "Void Transaction History",
    component: <VoidTransactionHistory />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/refund-transaction-history",
    name: "Refund Transaction History",
    component: <RefundTransactionHistory />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/worker-reports/payment-success-failure-report",
    name: "Payment Success/Failure Report",
    component: <PaymentSuccessFailureReport />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Reports",
  },
  {
    path: "/appointment-confirm",
    name: "Confirm Appointment",
    icon: <img src={AppoinmentWhite} alt="Confirm Appointment" />,
    icon2: <img src={AppoinmentBlue} alt="Confirm Appointment" />,
    component: <ConfirmAppointment />,
    layout: "/:CompanyUrl/staff-member",
    isDisplay: false,
    module: "Appointment",
  },
  {
    path: "/theme",
    name: "Theme",
    icon: <img src={AppoinmentWhite} alt="Theme" />,
    icon2: <img src={AppoinmentBlue} alt="Theme" />,
    component: <Theme />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Theme",
  },
  {
    path: "/date-format",
    name: "Date Format",
    icon: <img src={AppoinmentWhite} alt="Date Format" />,
    icon2: <img src={AppoinmentBlue} alt="Date Format" />,
    component: <DateTimeFormat />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Date Format",
  },
  {
    path: "/timezone",
    name: "Timezone",
    icon: <img src={AppoinmentWhite} alt="Timezone" />,
    icon2: <img src={AppoinmentBlue} alt="Timezone" />,
    component: <DateTimeFormat />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Timezone",
  },
  {
    path: "/name-format",
    name: "Name Format",
    icon: <img src={AppoinmentWhite} alt="Name Format" />,
    icon2: <img src={AppoinmentBlue} alt="Name Format" />,
    component: <NameFormat />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Name Format",
  },
  {
    path: "/time-format",
    name: "Time Format",
    icon: <img src={AppoinmentWhite} alt="Time Format" />,
    icon2: <img src={AppoinmentBlue} alt="Time Format" />,
    component: <DateTimeFormat />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Time Format",
  },
  {
    path: "/logo-setting",
    name: "Logo Setting",
    component: <LogoSetting />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Logo Setting",
  },
  {
    path: "/donation-link",
    name: "Donation Link",
    component: <DonationLinkSetting />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Donation Link",
  },

  // Logs
  {
    path: "/activity",
    name: "Activity",
    icon: <img src={AppoinmentWhite} alt="Activity" />,
    icon2: <img src={AppoinmentBlue} alt="Activity" />,
    component: <Activity />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Activity",
  },
  {
    path: "/add-templates",
    name: "Add Templates",
    icon: <img src={AppoinmentWhite} alt="Add Templates" />,
    icon2: <img src={AppoinmentBlue} alt="Add Templates" />,
    component: <AddTemplates />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Templates",
  },
  {
    path: "/add-email-campaign",
    name: "Add Email Campaign",
    icon: <img src={AppoinmentWhite} alt="Add Email Campaign" />,
    icon2: <img src={AppoinmentBlue} alt="Add Email Campaign" />,
    component: <AddEmailCampaign />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Templates",
  },
  {
    path: "/email-campaign-details",
    name: "Email Campaign Details",
    icon: <img src={AppoinmentWhite} alt="Email Campaign Details" />,
    icon2: <img src={AppoinmentBlue} alt="Email Campaign Details" />,
    component: <EmailCampaignDetails />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Templates",
  },
  {
    path: "/add-new-email",
    name: "Add New EMail",
    icon: <img src={AppoinmentWhite} alt="Add New EMail" />,
    icon2: <img src={AppoinmentBlue} alt="Add New EMail" />,
    component: <AddNewEmail />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Templates",
  },
  {
    path: "/Surcharge",
    name: "Surcharge",
    icon: <img src={AppoinmentWhite} alt="Surcharge" />,
    icon2: <img src={AppoinmentBlue} alt="Surcharge" />,
    component: <Surcharge />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Surcharge",
  },
  {
    path: "/account",
    name: "Account",
    icon: <img src={AppoinmentWhite} alt="Account" />,
    icon2: <img src={AppoinmentBlue} alt="Account" />,
    component: <Accountsetting />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Account",
  },
  
  // {
  //   path: "/reports",
  //   name: "Reports",
  //   icon: <img src={ReportWhite} />,
  //   icon2: <img src={ReportBlue} />,
  //   component: <Reports />,
  //   layout: "/:CompanyUrl",
  //   isDisplay: true,
  //   module: "Reports",
  // },
  {
    path: "/make-payment",
    name: "make payment",
    icon: <img src={ReportWhite} alt="make payment" />,
    icon2: <img src={ReportBlue} alt="make payment" />,
    component: <MakePayment />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "make payment",
  },
  {
    path: "/company-setting",
    name: "Company Setting",
    icon: <img src={ReportWhite} alt="Company Setting" />,
    icon2: <img src={ReportBlue} alt="Company Setting" />,
    component: <CompanySetting />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "make payment",
  },
  // {
  //   path: "/reports-details",
  //   name: "Generate Report",
  //   icon: <SentimentSatisfiedOutlinedIcon />,
  //   icon2: <img src={QuoteBlue} />,
  //   component: <PaymentReport />,
  //   layout: "/:CompanyUrl",
  //   isDisplay: false,
  //   module: "Reports",
  // },
  // {
  //   path: "/financial",
  //   name: "Financial",
  //   icon: <SentimentSatisfiedOutlinedIcon />,
  //   icon2: <img src={QuoteBlue} />,
  //   component: <Financial />,
  //   layout: "/:CompanyUrl",
  //   isDisplay: true,
  //   module: "Reports",
  // },
  {
    path: "/transaction-settings",
    name: "Transaction Settings",
    component: <TransactionSettings />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Settings",
  },
  {
    path: "/payment-processing",
    name: "Batch Settlement Time",
    component: <BatchSettings />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Settings",
  },
  {
    path: "/payment-terminals",
    name: "Payment Terminals",
    component: <PaymentTerminalIndex />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Settings",
  },
  {
    path: "/disclaimer",
    name: "Disclaimer",
    component: <Disclaimer />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Settings",
  },

  // ======================== Donor ======================

  {
    path: "/index",
    name: "Dashboard",
    icon: <img src={DashboardWhite} alt="Dashboard" />,
    icon2: <img src={DashboardBlue} alt="Dashboard" />,
    component: <DonorDashboard />,
    layout: "/:CompanyUrl/donors",
    isDisplay: true,
    module: "Donor",
  },
  {
    path: "/General-ledger",
    name: "General Ledger",
    icon: <img src={DonorLedgerWhite} alt="General Ledger" />,
    icon2: <img src={DonorLedgerBlue} alt="General Ledger" />,
    component: <DonorGeneralLedger />,
    layout: "/:CompanyUrl/donors",
    isDisplay: true,
    module: "General Ledger",
  },

  {
    path: "/make-donation",
    name: "Make Donation",
    icon: <img src={MakePaymentWhite} alt="Make Donation" />,
    icon2: <img src={MakePaymentBlue} alt="Make Donation" />,
    component: <MakeDonation />,
    layout: "/:CompanyUrl/donors",
    isDisplay: true,
    module: "Make Donation",
  },
  {
    path: "/profile",
    name: "Profile",
    component: <DonorProfile />,
    layout: "/:CompanyUrl/donors",
    isDisplay: false,
    module: "Donor",
  },
  {
    path: "/recurring-pledges",
    name: "Recurring Donations",
    icon: <img src={PaymentWhite} alt="Recurring Donations" />,
    icon2: <img src={PaymentBlues} alt="Recurring Donations" />,
    component: <RecurringPledges />,
    layout: "/:CompanyUrl/donors",
    isDisplay: true,
    module: "Recurring Donations",
  },
  {
    path: "/notes",
    name: "Notes",
    icon: <img src={NoteWhite} alt="Notes" />,
    icon2: <img src={NoteBlue} alt="Notes" />,
    component: <NotesDonor />,
    layout: "/:CompanyUrl/donors",
    isDisplay: true,
    module: "Notes",
  },
  // =============== DISPATCH (Phase 5.4h) ===============
  {
    path: "/dispatch-board",
    name: "Dispatch Board",
    icon: <MapOutlinedIcon />,
    icon2: <MapOutlinedIcon />,
    component: <DispatchBoard />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Dispatch",
  },
  {
    path: "/worker-location-map",
    name: "Worker Location Map",
    icon: <LocationOnOutlinedIcon />,
    icon2: <LocationOnOutlinedIcon />,
    component: <WorkerLocationMap />,
    layout: "/:CompanyUrl",
    isDisplay: false,
    module: "Dispatch",
  },
  // =============== TIME & ATTENDANCE ADMIN (Phase 5.4g) ===============
  {
    path: "/announcements",
    name: "Announcements",
    icon: <CampaignOutlinedIcon />,
    icon2: <CampaignOutlinedIcon />,
    component: <AnnouncementsPage />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "Announcements",
  },
  {
    path: "/time-off-requests",
    name: "Time-off Requests",
    icon: <EventAvailableOutlinedIcon />,
    icon2: <EventAvailableOutlinedIcon />,
    component: <TimeOffApprovalPage />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "TimeOff",
  },
  {
    path: "/shift-requests",
    name: "Shift Requests",
    icon: <SwapHorizOutlinedIcon />,
    icon2: <SwapHorizOutlinedIcon />,
    component: <ShiftTransactionsPage />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "ShiftRequests",
  },
  {
    path: "/time-reports",
    name: "Time Reports",
    icon: <AssessmentOutlinedIcon />,
    icon2: <AssessmentOutlinedIcon />,
    component: <TimeReportsPage />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "TimeReports",
  },
  {
    path: "/time-settings",
    name: "T&A Settings",
    icon: <TuneOutlinedIcon />,
    icon2: <TuneOutlinedIcon />,
    component: <TimeSettingsPage />,
    layout: "/:CompanyUrl",
    isDisplay: true,
    module: "TimeSettings",
  },
  // =============== KIOSK (Phase 5.4g) — outside the admin layout ===============
  {
    path: "/:companyUrl",
    name: "Kiosk",
    component: <KioskPage />,
    layout: "/kiosk",
    isDisplay: false,
  },
];

export default routes;
